module.exports = __webpack_public_path__ + "static/img/hotel.ef243a67.png";